// Ciudades destacadas de la home ("Elige tu ciudad"). Misma filosofía
// que los artistas destacados: una ÚNICA lista ordenada gestionada por
// el admin y persistida como documento Cosmos singleton. A diferencia
// de los artistas, una ciudad NO tiene id/slug/imagen propios: es sólo
// un nombre (el `DisplayName` de la faceta `cities`), que es a la vez
// identificador y valor del filtro `city` del listado.
import { z } from 'zod';

/**
 * Referencia a una ciudad dentro de la lista destacada. `name` es el
 * nombre de la ciudad (valor del filtro). `position` es 0-based.
 */
export const FeaturedCityRefSchema = z.object({
  name: z.string().min(1),
  position: z.number().int().nonnegative(),
});
export type FeaturedCityRef = z.infer<typeof FeaturedCityRefSchema>;

/**
 * Item admin del singleton — lo que devuelve `GET /admin/featured-cities`.
 * Incluye `_etag` para concurrencia optimista en el `PUT`.
 */
export const FeaturedCitiesAdminItemSchema = z.object({
  cities: z.array(FeaturedCityRefSchema),
  updatedAt: z.string().nullable(),
  _etag: z.string().optional(),
});
export type FeaturedCitiesAdminItem = z.infer<
  typeof FeaturedCitiesAdminItemSchema
>;

/**
 * Input del `PUT /admin/featured-cities`. El orden del array define la
 * posición; se reemplaza la lista entera (no es un delta).
 */
export const UpdateFeaturedCitiesInputSchema = z.object({
  cities: z.array(z.string().min(1)),
});
export type UpdateFeaturedCitiesInput = z.infer<
  typeof UpdateFeaturedCitiesInputSchema
>;

/**
 * DTO público de una ciudad destacada para la home
 * (`GET /v1/home/cities`).
 */
export const FeaturedCityPublicSchema = z.object({
  name: z.string(),
});
export type FeaturedCityPublic = z.infer<typeof FeaturedCityPublicSchema>;

export const FeaturedCitiesPublicResponseSchema = z.object({
  cities: z.array(FeaturedCityPublicSchema),
});
export type FeaturedCitiesPublicResponse = z.infer<
  typeof FeaturedCitiesPublicResponseSchema
>;
